import styled from 'styled-components';
import Badge from '../../../Badge';
import { floatingComponentStyles } from '../../../../styles/shareableStyles';
import { theme } from '../../../../styles/theme';

export const Container = styled.div`
  min-width: 550px;
  ${floatingComponentStyles};
`;

export const Header = styled.div`
  padding: 18px 24px;
  border-bottom: 1px solid ${theme.colors.border};
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: ${theme.colors.secondary900};
`;

export const Body = styled.div`
  padding: 12px 16px;
`;

export const DateRangeContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;
export const TimeZoneBadge = styled(Badge)`
  // reduce grid-column-gap by 8px
  margin-left: -8px;
`;
